import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { NotificationApi } from "src/services/notification/notification";

export interface NotificationInterface {
  [key: string]: {
    logs?: [
      {
        logType: "SUCCESS" | "ERROR";
        title: string;
        desc: string;
        timestamp: Date;
      }
    ];
    hasDeviated: boolean;
  };
}

const initialState: NotificationInterface = {
  // "6221878da22e26c2adc72b23": {
  //   logs: [
  //     {
  //       logType: "ERROR",
  //       title: "Vehicle on the wrong route",
  //       desc: "Vehicle started moving on a non designated route for 24 kms",
  //     },
  //   ],
  //   hasDeviated: false,
  // },
};

interface PayloadInterface {
  id: string;
  logType: "SUCCESS" | "ERROR";
  hasDeviated: boolean;
}

export const NotificationSlice = createSlice({
  name: "Notifications",
  initialState,
  reducers: {
    addLog: (
      state: NotificationInterface,
      action: PayloadAction<PayloadInterface>
    ) => {
      switch (action.payload.logType) {
        case "SUCCESS":
          if (state[action.payload.id]) {
            if (state[action.payload.id].hasDeviated) {
              const allLogs = state[action.payload.id].logs;
              allLogs?.push({
                logType: "SUCCESS",
                title: "Vehicle started moving",
                desc: "Vehicle started moving and is following the suggested route.",
                timestamp: new Date(),
              });
              state[action.payload.id].logs = allLogs;
              state[action.payload.id].hasDeviated = false;
            }
            else{
              state[action.payload.id].hasDeviated = false;
            }
          } else {
            state[action.payload.id] = {
              logs: [
                {
                  logType: "SUCCESS",
                  title: "Vehicle started moving",
                  desc: "Vehicle started moving and is following the suggested route.",
                  timestamp: new Date(),
                },
              ],
              hasDeviated: false,
            };
          }
          break;

        case "ERROR":
          // Check if order exists in notification object
          if (state[action.payload.id]) {
            if (!state[action.payload.id].hasDeviated) {
              const allLogs = state[action.payload.id].logs;
              allLogs?.push({
                logType: "ERROR",
                title: "Vehicle on the wrong route",
                desc: "Vehicle started moving on a non designated route",
                timestamp: new Date(),
              });
              state[action.payload.id].logs = allLogs;
              state[action.payload.id].hasDeviated = true;
            } else {
              state[action.payload.id].hasDeviated = true;
            }
          } else {
            state[action.payload.id] = {
              logs: [
                {
                  logType: "ERROR",
                  title: "Vehicle on the wrong route",
                  desc: "Vehicle started moving on a non designated route",
                  timestamp: new Date(),
                },
              ],
              hasDeviated: true,
            };
          }

          break;

        default:
          break;
      }
    },
  },
});

export const { addLog } = NotificationSlice.actions;

export default NotificationSlice.reducer;
